import environment from 'venuescanner-rails/app/javascript/environmentLoader';
import urlsJSON from 'venuescanner-js/config/urls.json';

const urlsEnv = function (env) {
  if (env === 'DEV' || env === 'development' ) env = 'DEVELOPMENT';
  // console.log({ endpoints, env })
  return {
    urls: {
      ...urlsJSON.DEVELOPMENT,
      ...urlsJSON[env],
    },
  };
};
const { urls: envUrls } = urlsEnv(environment.env);
// window.envUrls = envUrls
export const urls = envUrls;
export const host = envUrls.BACKEND_URL.replace(/\/$/, '');
export const rails = envUrls.RAILS_URL.replace(/\/$/, '');
export const railsApi = `${envUrls.API_SERVICE_URL.replace(/\/$/, '')}/api/v1`;
// TODO: most of this is deprecated by e.g.:  controllers.enquiry.enquire.post from ./controllers
export const endpoints = {
  sendEnquiryUrl: `send-enquiry`,
  eventSearchUpdate: 'eventSearchUpdate',
};

export const absoluteEndpoints = {
  sendEnquiryUrl: `${host}/send-enquiry`,
  eventSearchUpdate: `${host}/eventSearchUpdate`,
};

const collection = {
  urls: envUrls,
  endpoints,
  absoluteEndpoints,
};
if (typeof window !== 'undefined') {
  window.urls = collection.urls;
  window.endpoints = collection.endpoints;
  window.absoluteEndpoints = collection.absoluteEndpoints;
}
export default collection;
